import { Styles } from "../../../../types/common";

const styles: Styles = {
  filterBox: {
    "& .header": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "8px",
      borderBottom: "1px solid #C8C8C8",
      "& .filter_label": {
        fontSize: "24px",
        fontWeight: "700",
        color: "#23085A",
      },
      "& .reset_label": {
        color: "#AB0033",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          cursor: "pointer",
          "& .text": {
            textDecoration: "underline",
          },
        },
        "& .text": {
          fontSize: "16px",
          fontWeight: "700",
        },
      },
    },
  },
  examCenter: {
    marginBottom: "25px",
    border: "1px solid rgba(3, 92, 103, 0.25)",
    borderRadius: "16px",
    marginTop: "64px",
    "& .upper_header": {
      backgroundColor: "#F0FCF8",
      padding: "24px",
      fontSize: "16px",
      borderRadius: "16px 16px 0 0",
      "& .label": {
        fontSize: "12px",
      },
      "& .sub_label": {
        fontWeight: "700",
      },
    },
    "& .lower_table": {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "white",
      "& .table_head": {
        "& th": {
          fontSize: "12px",
          textAlign: "left",
          padding: "20px 10px",
        },
        "& .padding_left": {
          paddingLeft: "20px",
        },
      },
      "& .row_cell": {
        borderTop: "1px solid #8feef0",
        "& td": {
          fontSize: "12px",
          textAlign: "left",
          padding: "20px 10px",
        },
        "& .padding_left": {
          paddingLeft: "20px",
        },
      },
    },
    ".table_header": {
      fontSize: "14px",
      fontWeight: "700",
      color: "#23085A",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      svg: {
        fontSize: "16px",
      },
      "& .tooltip": {
        position: "relative",
        display: "flex",
        "& .tooltip_text": {
          display: "none",
          position: "absolute",
          zIndex: "22",
          top: "15px",
          left: "100%",
          color: "black",
          background: "white",
          border: "1px solid",
          borderRadius: "4px",
          padding: "2px",
          fontSize: "12px",
        },
        "&:hover": {
          "& .tooltip_text": {
            display: "block",
          },
        },
      },
    },
    ".status_cell": {
      display: "flex",
      alignItems: "center",
      borderRadius: "16px",
      padding: "4.5px 10px",
      gap: "5px",
      fontSize: "14px",
    },
    ".status_cell--Limited": {
      background: "rgba(255, 227, 0, 0.25)",
      color: "#472029",
    },
    ".status_cell--Full": {
      background: "rgba(255, 186, 184, 0.25)",
      color: "#AB0033",
    },
    ".status_cell--Closed": {
      background: "rgba(255, 186, 184, 0.25)",
      color: "#AB0033",
    },
    ".status_cell--Available": {
      color: "#00953B",
      background: "rgba(192, 223, 136, 0.25)",
    },
    ".register_section": {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      color: "#009D8C",
      fontWeight: "700",
      ":hover": {
        cursor: "pointer",
        textDecoration: "underline",
      },
      svg: {
        fontSize: "16px",
      },
    },
  },
  gridTable: {
    ".MuiDataGrid-root": {
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px",
      fontSize: "14px",
    },
    ".MuiDataGrid-footerContainer": {
      display: "none",
    },
    ".MuiDataGrid-iconButtonContainer": {
      visibility: "visible",
    },
    ".MuiDataGrid-sortIcon": {
      opacity: "inherit !important",
    },
    ".MuiDataGrid-columnHeaders": {
      minHeight: "auto !important",
      maxHeight: "100% !important",
      lineHeight: "inherit !important",
      borderRadius: 0,
    },
    ".MuiDataGrid-virtualScrollerContent": {
      height: "auto !important",
    },
    ".MuiDataGrid-virtualScrollerRenderZone": {
      position: "relative",
      "& div[role='row']": {
        maxHeight: "inherit !important",
        minHeight: "inherit !important",
        borderBottom: "1px solid #DFE0E0",
        "&.MuiDataGrid-row--lastVisible": {
          borderBottom: "none",
        },
      },
      ".MuiDataGrid-cell": {
        height: "auto !important",
        maxHeight: "inherit !important",
        minHeight: "inherit !important",
        padding: "16px 10px",
        outline: "none !important",
        border: "none",
        whiteSpace: "normal !important",
        justifyContent: "center",
        ".MuiDataGrid-cellContent": {
          fontSize: "13px",
        },
        "&:nth-of-type(1)": {
          justifyContent: "flex-start",
        },
      },
    },
    "& .MuiDataGrid-columnHeadersInner": {
      "& div[role='row']": {
        justifyContent: "space-between",
        background: "#DFE0E0",
        padding: "20px 10px",
      },
      "& .MuiDataGrid-menuIcon": {
        display: "none",
      },
      "& .MuiDataGrid-columnHeader": {
        height: "auto !important",
        padding: "0",
        outline: "none",
        ".MuiDataGrid-iconButtonContainer": {
          width: "auto",
        },
        ".MuiDataGrid-columnHeaderTitle": {
          fontSize: "14px",
          fontWeight: "700",
          color: "#23085A",
        },
        ".MuiDataGrid-columnHeaderTitleContainer": {
          justifyContent: "center",
          overflow: "visible",
        },
        ".MuiDataGrid-columnHeaderTitleContainerContent": {
          overflow: "visible",
        },
        ".MuiIconButton-sizeSmall": {
          padding: "2px",
          fontSize: "1rem",
        },
      },
      "& .MuiDataGrid-columnSeparator": {
        display: "none",
      },
    },
  },
  modalBody: {
    borderRadius: "8px",
    background: "#F0FCF8",
    padding: "16px",
    marginBottom: "28px",
  },
};

export default styles;
